import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { addToSearchHistory } from '../utils/dataManager';

const SearchBar = () => {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const handleSearch = async (e) => {
    e.preventDefault();
    if (keyword.trim()) {
      // 添加到搜索历史
      await addToSearchHistory(keyword.trim());
      // 导航到搜索结果页
      navigate(`/search?q=${encodeURIComponent(keyword.trim())}`);
      // 清空搜索框
      setKeyword('');
    }
  };

  return (
    <form onSubmit={handleSearch} className="relative">
      <input
        type="text"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        placeholder="搜索逸流珠宝、水晶首饰..."
        className="w-full py-2 px-4 pr-10 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
      />
      <button
        type="submit"
        className="absolute right-0 top-0 mt-2 mr-3 text-gray-400 hover:text-primary"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </button>
    </form>
  );
};

export default SearchBar;